<template>
  <v-row
    :align="$vuetify.breakpoint.smAndDown ? 'center' : 'start'"
    :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'start'"
    class="py-6 py-md-12 mx-0 px-6"
    data-aos="zoom-in-up"
    data-aos-easing="linear"
    data-aos-duration="5000"
  >
    <v-col cols="12" :md="titlecol" class="mb-6">
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'text-center primary--text' : 'primary--text'">Permítenos resolver tus dudas</h1>
    </v-col>
    <v-col cols="10" :lg="questionscol">
      <v-expansion-panels flat>
        <v-expansion-panel
          v-for="(item, i) in questions"
          :key="i"
          class="border"
        >
          <v-expansion-panel-header class="font-weight-bold font-italic">
            {{ item.q }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ item.r }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>
<style scoped>
.border {
  border: 1px solid #88888866;
  margin-bottom: 1rem;
}
</style>

<script>
export default {
  props: ["titlecol","questionscol"],
  name: "FAQ",
  data: () => ({
    questions: [
        {
          q: "¿Cómo hago llegar mis documentos?",
          r:
            "Una vez que has completado el pago de la inscripción te enviaremos una guía de paquetería prepagado que llegará a tu domicilio para que envíes la documentación sin costo para ti. Nosotros te confirmaremos cuando la hayamos recibido o podrás hacer un rastreo del paquete vía internet."
        },
        {
          q:
            "¿Desde qué navegador puedo ingresar para poder estudiar en linea?",
          r:
            "La plataforma educativa está diseñada para poder ser abierta desde Google Chrome, Internet Explorer, Firefox, Opera y Safari, por lo que no tendrás problemas para revisar tus cursos en los que estás inscrito."
        },
        {
          q: "¿Puedo saber quiénes serán mis profesores?",
          r:
            "Tus profesores son profesionistas con experiencia profesional y docente en el sistema Vizcaya en sus campus presenciales. Te comentamos que los cursos han sido diseñados por especialistas y serán atendidos por profesores tutores para apoyarte en la resolución de dudas y para la elaboración de las actividades de aprendizaje. Cada curso contiene los créditos correspondientes al equipo de profesionales que participó en su diseño."
        },
        {
          q: "¿Mis profesores están capacitados?",
          r:
            "Gracias a la gran infraestructura de Universidad Vizcaya hemos podido contactar y reclutar a los mejores docentes de cada materia para participar en educación a distancia."
        }
    ],
  }),
};
</script>